const checkboxSize = '{sizes.m}';
const checkbox = {
  root: {
    borderRadius: '{border.radius.s}',
    width: checkboxSize,
    height: checkboxSize,
    background: 'white',
    checkedBackground: '{primary.color}',
    checkedHoverBackground: '{primary.color}',
    disabledBackground: '{form.field.disabled.background}',
    filledBackground: '{form.field.filled.background}',
    borderColor: '{gray.scale.600}',
    hoverBorderColor: '',
    focusBorderColor: '{form.field.border.color}',
    checkedBorderColor: '{primary.color}',
    checkedHoverBorderColor: '',
    checkedFocusBorderColor: '{primary.color}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    shadow: '{form.field.shadow}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    transitionDuration: '{form.field.transition.duration}',
    transition: 'all {form.field.transition.duration}',
    sm: {
      width: checkboxSize,
      height: checkboxSize,
    },
  },
  icon: {
    size: '0.875rem',
    color: '{form.field.color}',
    checkedColor: '{primary.contrast.color}',
    checkedHoverColor: '{primary.contrast.color}',
    disabledColor: '{form.field.disabled.color}',
    marginTop: '4px',
  },
  checkmark: {
    color: '{white}',
    backgroundColor: '{white}',
    borderColor: '{dark}',
    borderRadius: '{border.radius.s}',
    borderWidth: '1px',
    size: checkboxSize,
    vrMargin: '{spacing.xxs}',
    transition: 'all {form.field.transition.duration}',
    disabled: {
      color: '{white}',
      backgroundColor: '{disabled}',
      borderColor: '{disabled}',
    },
    after: {
      backgroundColor: '{white}',
      borderWidth: '{spacing.xxxs}',
      color: '{white}',
      height: '.6rem',
      width: '0.33rem',
      bottom: '0.14em',
      left: '0',
      margin: '0 0.25em',
      primary: {
        backgroundColor: '{primary.color}',
        borderColor: '{primary.color}',
      },
      secondary: {
        backgroundColor: '{secondary.color}',
        borderColor: '{secondary.color}',
      },
      tertiary: {
        backgroundColor: '{gray.scale.700}',
        borderColor: '{gray.scale.700}',
      },
    },
    indeterminate: {
      borderWidth: '0.175rem 0 0 0',
      top: '0.275rem',
      width: '0.42em',
    },
  },
  checked: {
    disabledBorderColor: '{form.field.disabled.background}',
  },
};

export default checkbox;
